{
    "RecordingList_Column_Description": "Beschreibung",
    "RecordingList_Column_Type": "Typ",
    "RecordingList_Column_TelSys": "Telefonieserver",
    "RecordingList_Column_Partition": "Partition",
    "RecordingList_Scope_All": "Alle",
    "RecordingList_Scope_ServiceWide": "Serviceweit",
    "RecordingList_Scope_SystemWide": "Systemweit",
    "RecordingList_Scope_Detached": "Losgelöst",
    "RecordingList_Type_All": "Alle",
    "RecordingList_Type_Dubber": "Synchronsprecher",
    "RecordingList_Scope_Label": "Umfang",
    "RecordingList_Type_Label": "Typ",
    "NAME": "AufnahmelisteSprache"
}